import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ComponentsService } from 'src/app/components.service';
import { AbstractComponent } from '../abstract.component';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss']
})
export class SettingsComponent
    extends AbstractComponent
    implements OnInit, OnDestroy
{
    gameCode: string;
    activeTab: number = 1;
    clientId: number;
    showStartButton: boolean = false;
    showStopButton: boolean = false;

    showSuperPinTable: boolean = false;
    confirmationVisible = false;
    confirmationMessage = '';
    confirmationAction: 'start' | 'stop' | null = null;

    constructor(
        private activeRoute: ActivatedRoute,
        private service: ComponentsService
    ) {
        super();
    }

    ngOnInit() {
        this.activeRoute.params.subscribe((params) => {
            this.gameCode = params.gameCode;
            this.service
                .getSingleBettingStatus(
                    this.service.getClientUuid(),
                    params.gameCode
                )
                .subscribe((data) => {
                    const { bet_allowed } = data;
                    this.showStartButton = bet_allowed === 0;
                    this.showStopButton = bet_allowed === 1;
                });
        });
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    changeTableView(tab: number) {
        this.activeTab = tab;
    }

    showStartMessage() {
        this.confirmationMessage = 'START betting service?';
        this.confirmationAction = 'start';
        this.confirmationVisible = true;
    }

    showStopMessage() {
        this.confirmationMessage = 'STOP betting service?';
        this.confirmationAction = 'stop';
        this.confirmationVisible = true;
    }

    onConfirmAction() {
        const status = this.confirmationAction === 'start' ? 1 : 0;

        this.service
            .setSingleBettingStatus(status, this.gameCode)
            .subscribe(() => {
                this.showStartButton = !this.showStartButton;
                this.showStopButton = !this.showStopButton;
            });

        this.confirmationAction = null;
    }
}
